import AuthTokenModelBase from '../_generated/modelBases/auth-token-model-base';

export default class AuthTokenModel extends AuthTokenModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
